import {
  AppLoginMethods,
  LOCIZE_LOGIN_TRANSLATION_KEYS,
  LocizeNamespaces,
} from 'app-constants';
import type { ButtonProps, ButtonVariant } from 'components/ui/button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';

type UseAppLoginButtons = {
  loginMethodButtons: Array<
    ButtonProps & { method: AppLoginMethods; label: string }
  >;
  selectedLoginMethod: AppLoginMethods;
};

const setButtonVariant = (
  method: AppLoginMethods,
  selectedMethod: AppLoginMethods,
): ButtonVariant => {
  return method === selectedMethod ? 'black' : 'grey';
};

export const useLoginMethodButtons = (): UseAppLoginButtons => {
  const { t } = useTranslation(LocizeNamespaces.login);

  const [selectedLoginMethod, setSelectedLoginMethod] = useState(
    AppLoginMethods.smartId,
  );

  const loginMethodButtons = [
    {
      method: AppLoginMethods.mobileId,
      variant: setButtonVariant(AppLoginMethods.mobileId, selectedLoginMethod),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.mobileId),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.mobileIdMethodButtonLabel),
      key: uuid(),
    },
    {
      method: AppLoginMethods.smartId,
      variant: setButtonVariant(AppLoginMethods.smartId, selectedLoginMethod),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.smartId),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.smartIdMethodButtonLabel),
      key: uuid(),
    },
    {
      method: AppLoginMethods.idCard,
      variant: setButtonVariant(AppLoginMethods.idCard, selectedLoginMethod),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.idCard),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.idCardMethodButtonLabel),
      key: uuid(),
    },
    {
      method: AppLoginMethods.banklink,
      variant: setButtonVariant(AppLoginMethods.banklink, selectedLoginMethod),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.banklink),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.banklinkMethodButtonLabel),
      key: uuid(),
    },
    {
      method: AppLoginMethods.eParakstsSmartCard,
      variant: setButtonVariant(
        AppLoginMethods.eParakstsSmartCard,
        selectedLoginMethod,
      ),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.eParakstsSmartCard),
      label: t(
        LOCIZE_LOGIN_TRANSLATION_KEYS.eParakstsSmartCardMethodButtonLabel,
      ),
      key: uuid(),
    },
    {
      method: AppLoginMethods.eParakstsMobile,
      variant: setButtonVariant(
        AppLoginMethods.eParakstsMobile,
        selectedLoginMethod,
      ),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.eParakstsMobile),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.eParakstsMobileMethodButtonLabel),
      key: uuid(),
    },
    {
      method: AppLoginMethods.password,
      variant: setButtonVariant(AppLoginMethods.password, selectedLoginMethod),
      onClick: () => setSelectedLoginMethod(AppLoginMethods.password),
      label: t(LOCIZE_LOGIN_TRANSLATION_KEYS.passwordMethodButtonLabel),
      key: uuid(),
    },
  ];

  return {
    loginMethodButtons,
    selectedLoginMethod,
  };
};
